import type { OnDestroy } from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GoogleAnalyticsApiService } from '@common/modules/gtm/google-analytics.service';
import { take, takeUntil } from 'rxjs/operators';
import { deepClone } from '@common/helpers/deep-clone';
import { Subject } from 'rxjs';

declare const dataLayer: Array<any>;

@Injectable()
export class RouterSubscription implements OnDestroy {
    private router = inject(Router);
    private googleAnalyticsApiService = inject(GoogleAnalyticsApiService);

    private readonly unsubscribe$ = new Subject<void>();

    public initSubs() {
        this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.googleAnalyticsApiService
                    .getDataLayer(event.urlAfterRedirects)
                    .pipe(takeUntil(this.unsubscribe$), take(1))
                    .subscribe((response) => {
                        console.log(response);
                        if (response && response.dataLayer) {
                            const dataLayerCopy = deepClone(response.dataLayer);
                            dataLayerCopy.event = 'spa_page_view';
                            dataLayer?.push(dataLayerCopy);
                            this.googleAnalyticsApiService.initializeGTM(response.dataLayer);
                        }
                    });
            }
        });
    }

    public ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
